import { render, staticRenderFns } from "./index.vue?vue&type=template&id=08b64a75&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=08b64a75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b64a75",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08b64a75')) {
      api.createRecord('08b64a75', component.options)
    } else {
      api.reload('08b64a75', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=08b64a75&scoped=true&", function () {
      api.rerender('08b64a75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_islide_landing/components/AppSale/index.vue"
export default component.exports